<template>
    <li class="nav-item">
        <component
            :is="tag"
            class="nav-link"
            v-bind="$attrs"
            @click="hideSidebar"
        >
            <slot>
                <i v-if="icon"
                   :class="icon"></i>
                <p>{{ name }}</p>
            </slot>
        </component>
    </li>
</template>
<script>
export default {
    name: 'sidebar-link',
    inheritAttrs: false,
    inject: {
        autoClose: {
            default: true,
        },
        addLink: {
            default: () => {},
        },
        removeLink: {
            default: () => {},
        },
    },
    props: {
        name: String,
        icon: String,
        tag: {
            type: String,
            default: 'router-link',
        },
    },
    data() {
        return {
            sidebar: inject('sidebar'),
        };
    },
    methods: {
        hideSidebar() {
            if (this.autoClose) {
                this.sidebar.displaySidebar(false);
            }
        },
        isActive() {
            return this.$el.classList.contains('active');
        },
    },
    mounted() {
        if (this.addLink) {
            this.addLink(this);
        }
    },
    beforeUnmount() {
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
        if (this.removeLink) {
            this.removeLink(this);
        }
    },
};
</script>
<style></style>
